import React from "react"
import { Button, Box } from "@chakra-ui/react"

type Props = {
  text: string
}

export default function CtaButton(props: Props): JSX.Element {
  return (
    <Box>
      <Button
        as="a"
        href="#pricing"
        size="md"
        fontWeight={500}
        variant="ctaSolidLight"
      >
        {props.text}
      </Button>
    </Box>
  )
}
